import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // Import useParams for dynamic routing
import { Typography, Box, Paper, Button } from "@mui/material";
import { cardData } from "./data";

const DynamicPage = () => {
  const { pageId } = useParams(); // Get the dynamic page id from the URL
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    // Fetch the correct content based on the dynamic route
    const foundData = cardData.find((item) => item.id === pageId);
    console.log(foundData, "DynamicPage");
    if (foundData) {
      setPageData(foundData);
    }
  }, [pageId]);

  if (!pageData) {
    return (
      <Typography
        variant="h6"
        sx={{
          padding: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 }, // Responsive padding
          textAlign: "center",
          color: "#002367",
          fontFamily: "Light",
          fontSize: { xs: 14, sm: 16, md: 18, lg: 20, xl: 22 }, // Responsive font size
        }}
      >
        Page not found
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        padding: { xs: 1, sm: 2, md: 3, lg: 4, xl: 5 }, // Responsive padding
        // backgroundColor: "#f4f4f9",
        minHeight: "100vh",
        justifySelf: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // Center content horizontally
      }}
    >
      <Typography
        variant="h3"
        sx={{
          marginBottom: { xs: 1, sm: 2, md: 3, lg: 4, xl: 5 }, // Responsive margin
          color: "#002367",
          fontFamily: "Light",
          fontWeight: "700",
          fontSize: { xs: 18, sm: 24, md: 30, lg: 36, xl: 42 }, // Responsive font size
          whiteSpace: "normal", // Allow text to wrap
          wordBreak: "break-word", // Break words if too long
        }}
      >
        {pageData.title}
      </Typography>
      {/* Centered Image */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center", // Horizontally center the image
          width: { xs: "90%", sm: "85%", md: "80%", lg: "85%", xl: "80%" }, // Responsive width
          marginBottom: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 }, // Responsive margin
        }}
      >
        <img
          src={`/images/${pageData.src}`} // Image for the page
          alt={pageData.title}
          style={{
            width: "100%", // Full width of the parent Box
            height: "auto", // Maintain aspect ratio
            borderRadius: "8px",
            objectFit: "contain", // Ensure image fits without cropping
          }}
        />
      </Box>

      <Paper
        sx={{
          padding: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 }, // Responsive padding
          backgroundColor: "#fff",
          boxShadow: 3,
          width: { xs: "90%", sm: "85%", md: "80%", lg: "85%", xl: "80%" }, // Responsive width, matching image
          borderRadius: 2, // Slightly more rounded for consistency
        }}
      >
        <Typography
          variant="body1"
          sx={{
            marginBottom: { xs: 1, sm: 2, md: 3, lg: 4, xl: 5 }, // Responsive margin
            color: "#002367",
            fontFamily: "Light",
            fontWeight: "700",
            fontSize: { xs: 14, sm: 16, md: 20, lg: 22, xl: 24 }, // Responsive font size
            whiteSpace: "normal", // Allow text to wrap
            wordBreak: "break-word", // Break words if too long
          }}
        >
          {pageData.description}
        </Typography>

        {/* Render additionalInfo as an unordered list */}
        <ul>
          {pageData.additionalInfo.map((item, index) => (
            <li
              key={index}
              style={{
                marginBottom: "8px", // Spacing between each list item
                color: "#000000",
                fontFamily: "Light",
                fontSize: { xs: 9, sm: 9, md: 12, lg: 16, xl: 16 }, // Responsive font size
              }}
            >
              {item}
            </li>
          ))}
        </ul>
      </Paper>
    </Box>
  );
};

export default DynamicPage;
